import React from 'react';
import { ArrowLeftRight, X, Check } from 'lucide-react';

const CompareBox = ({
  title = 'Compare',
  before,
  after,
  beforeLabel = 'Before',
  afterLabel = 'After',
  beforeItems,
  afterItems,
}) => {
  return (
    <div className="my-8 bg-white/60 border border-courtyard-olive/20 rounded-2xl p-6 shadow-sm">
      <div className="flex items-center gap-2.5 mb-4">
        <div className="w-8 h-8 rounded-lg bg-courtyard-olive/15 flex items-center justify-center">
          <ArrowLeftRight className="w-4.5 h-4.5 text-courtyard-olive-dark" aria-hidden="true" />
        </div>
        <h4 className="font-display font-bold text-courtyard-stone text-base">{title}</h4>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <div className="bg-courtyard-clay/5 border border-courtyard-clay/15 rounded-xl p-4">
          <div className="flex items-center gap-1.5 mb-2.5">
            <X className="w-4 h-4 text-courtyard-clay" aria-hidden="true" />
            <p className="text-xs font-bold text-courtyard-clay uppercase tracking-wide">{beforeLabel}</p>
          </div>
          {before && <p className="text-sm text-courtyard-stone/75 leading-relaxed">{before}</p>}
          {beforeItems && (
            <ul className="space-y-1.5">
              {beforeItems.map((item, i) => (
                <li key={i} className="flex gap-2 text-sm text-courtyard-stone/75">
                  <span className="text-courtyard-clay mt-0.5" aria-hidden="true">&bull;</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="bg-courtyard-olive/5 border border-courtyard-olive/15 rounded-xl p-4">
          <div className="flex items-center gap-1.5 mb-2.5">
            <Check className="w-4 h-4 text-courtyard-olive-dark" aria-hidden="true" />
            <p className="text-xs font-bold text-courtyard-olive-dark uppercase tracking-wide">{afterLabel}</p>
          </div>
          {after && <p className="text-sm text-courtyard-stone/75 leading-relaxed">{after}</p>}
          {afterItems && (
            <ul className="space-y-1.5">
              {afterItems.map((item, i) => (
                <li key={i} className="flex gap-2 text-sm text-courtyard-stone/75">
                  <span className="text-courtyard-olive-dark mt-0.5" aria-hidden="true">&bull;</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompareBox;
